export default {
  common: {
    cancel: 'Отмена',
    save: 'Сохранить',
    close: 'Закрыть',
    back: 'Назад',
    done: 'Готово',
    reload: 'Перезагрузить',
    loading: 'Загрузка..',
    delete: 'Удалить',
    add: 'Добавить',
    update: 'Обновить',
    ok: 'OK',
    errorPrefix: 'Ошибка: {name}. {message}',
  },
  stop: {
    reason: {
      'out-of-stock': 'Закончился продукт',
      'too-busy': 'Не успеваем',
      'quality-issue': 'Проблема с качеством',
      'wait-and-retry': 'Подождать, пока освободимся',
      other: 'Другое',
    },
  },
  update: {
    newVersionHeader: 'Доступна новая версия',
    newVersionMessage: 'Обновить до новой версии?',
    yesReload: 'Да, перезагрузить',
    noIgnore: 'Нет, игнорировать',
    toastMessage: 'Новая версия: v{current} → v{latest}',
    toastMessageFallback: 'Доступна новая версия',
    statusUpToDate: 'Актуально',
    statusChecking: 'Проверяем…',
    statusAvailable: 'v{latest} доступна',
    checkNow: 'Проверить обновления',
    appVersion: 'Версия приложения',
  },
  auth: {
    addUser: 'Добавить пользователя',
    versionHeader: 'Версия',
    versionHashHeader: 'Хеш версии',
  },
  shift: {
    startShift: 'Начать смену',
    goToAccount: 'В аккаунт',
  },
  kitchen: {
    title: 'Кухня',
    table: 'Стол',
    noTable: 'Без стола',
    loadingBoard: 'Загрузка доски..',
    noOrders: 'Заказов пока нет',
    collapsedOrders:
      'Нет готовых | Ещё {n} позиция готова | Ещё {n} позиции готовы | Ещё {n} позиций готово',
    collapseOrders: 'Свернуть',
    tabs: {
      active: 'В работе',
      done: 'История',
      stopList: 'Стоп-лист',
    },
    stopList: {
      activeEmpty: 'Стоп-лист пуст',
      activeHeader: 'На стопе ({count})',
      allItemsHeader: 'Все позиции',
      searchPlaceholder: 'Поиск по меню',
      noMatches: 'Ничего не найдено',
      pickReason: 'Причина',
      pickUntil: 'До какого момента',
      pickScope: 'Что именно',
      scopeWholeItem: 'Всю позицию',
      pickerHeader: 'Поставить на стоп',
      commentLabel: 'Комментарий (необязательно)',
      commentPlaceholder: 'Подсказка официанту',
      save: 'Поставить на стоп',
      untilShift: 'До конца смены',
      until1h: '1 час',
      until3h: '3 часа',
      untilManual: 'До ручной отмены',
      untilMinutes: 'до окончания {count} мин',
      untilHours: 'до окончания {count} ч',
      clearConfirmTitle: 'Снять с стопа?',
      clearConfirmMessage: 'Снять {name} со стоп-листа?',
      clearConfirmYes: 'Да, снять',
      noItemsForMenu: 'В этом меню нет позиций для твоей роли',
      noAccessibleMenus: 'Нет доступных тебе меню',
      sidebarTitle: 'На стопе',
      sidebarEmptyHeading: 'Стоп-лист пуст',
      sidebarEmptyHint: 'Тапни блюдо справа, чтобы поставить на стоп',
    },
  },
  quickOrder: {
    title: 'Быстрый заказ',
    order: 'Заказ',
    clear: 'Очистить',
    sidebarPlaceholder: 'Добавь позиции слева',
  },
  order: {
    order: 'Заказ',
    itemOnStop: 'На стопе',
    orderUnknown: 'Неизвестный заказ',
    checkout: 'Расчёт',
    sendToWork: 'Отправить в работу',
    batch: 'ПАРТИЯ',
    draftBatch: 'ЧЕРНОВИК ПАРТИИ',
    addOrderToTable: 'Добавить заказ к столу',
    cancelOrder: 'Отменить заказ',
    assignToMe: 'Назначить на меня',
    reassignTo: 'Назначить на…',
    reassignPickHeader: 'Кому передать стол',
    reassignNoStaffOnShift: 'Сейчас никого нет на смене',
    items: 'нет позиций | {count} позиция | {count} позиции | {count} позиций',
    table: 'Стол',
    tableUnknown: 'Неизвестный стол',
    total: 'Итого',
    payment: 'Оплата',
    promotions: 'Промоушены',
    payCash: 'Наличными',
    payCard: 'Картой',
    startBatch: 'Начать партию',
    contentPlaceholder:
      'Нажми «Начать партию» в сайдбаре, чтобы добавить позиции.',
    receiptPrinted: 'Чек печатается...',
    finalise: 'Завершить',
    noOrderPlaceholder: 'Заказа ещё нет',
    createOrder: 'Создать заказ',
    addMenuItem: 'Добавить позицию',
    sidebarPlaceholder: 'Добавляй позиции справа',
    newOrder: 'Новый заказ',
    noItemsInCategory: 'В категории нет позиций',
    noMenusFound: 'Меню не найдены',
    added: 'Добавлено',
    commentAlert: {
      header: 'Введи комментарий',
      placeholder: 'Введи текст',
    },
    cancelConfirm: {
      header: 'Отмена заказа.',
      message: 'Подтверди отмену заказа.',
      yes: 'Да',
      no: 'Нет',
    },
    moveItems: {
      enter: 'Переместить',
      selectTarget: 'Выберите стол',
      submit: 'Перенести сюда',
      submitTo: 'Перенести {from} → {to}',
      cancel: 'Отмена',
      mustLeaveOne: 'Оставьте минимум 1 позицию',
      errorNotApplied: 'Перенос не выполнен',
      errorReverted: 'Перенос откачен',
      errorBroken: 'Перенос сломан — items в обоих ордерах: {ids}',
    },
  },
  transaction: {
    paid: 'Оплачено',
    reversed: 'Сторнировано',
    type: 'Тип',
    total: 'Итого',
    items: 'Позиции',
    label: 'Транзакция №{number}',
    reverse: 'Сторнировать',
    printFiscal: 'Печать фискального чека',
    printPreCheck: 'Печать пре-чека',
    loading: 'Загрузка транзакций..',
    newTransaction: 'Новая транзакция',
    creating: 'Создание транзакции..',
    addCash: 'Наличные',
    addCard: 'Карта',
    finalise: 'Завершить',
    printerNotConfigured: 'Принтер не настроен или не подключён',
    printerError: 'Ошибка от принтера: {response}',
    confirmPrint: {
      header: 'Распечатать фискальный чек?',
      message:
        'Подтверди печать фискального чека. Действие необратимо.',
      print: 'Печать',
    },
  },
  promotions: {
    sidebarTitle: 'Применённые промоушены',
    contentTitle: 'Добавить промоушен',
    sidebarPlaceholder: 'Добавляй промоушены справа',
    remove: 'Удалить',
    done: 'Готово',
    searchInputPlaceholder: 'Начни печатать',
    searchCancel: 'Отмена',
    searchPlaceholder: 'Начни печатать — здесь появятся результаты.',
    matchingPromotions: 'Подходящие промоушены',
    apply: 'Применить',
    applied: 'Применено',
    scanVoucher: 'Сканировать ваучер',
    noSuggestions: 'Нет предложенных промоушенов',
    noItemsFound: 'Позиций не найдено.',
    searchResults: 'Результаты поиска',
  },
  inHouse: {
    title: 'В зале',
    filterMap: 'Карта',
    filterStatus: 'Статус',
    filterWaiter: 'Официант',
    mapMove: 'Переместить',
    mapMoveCancel: 'Отмена',
    mapMoveSelectTable: 'Выбери стол, на который перенести',
    mapMoveTitle: 'Перенести заказ со стола {from} на {to}',
    tables: 'нет столов | {count} стол | {count} стола | {count} столов',
    noMapCreated: 'Карта не создана',
    statusWaitingTitle: 'Ждут',
    statusInProgressTitle: 'В процессе',
    statusIdleTitle: 'Кушают',
    statusCheckedOutTitle: 'Рассчитаны',
  },
  stock: {
    title: 'Склад',
    filterStock: 'Склад',
    filterGoods: 'Полуфабрикаты',
    filterOrders: 'Заявки',
    newOrder: 'Новая заявка',
    noStockAvailable: 'Нет доступного склада',
    noStockOrders: 'Нет складских заявок',
    noVendor: 'Без поставщика',
    statuses: {
      backlog: 'Бэклог',
      progress: 'В процессе',
      arrived: 'Прибыло',
      complete: 'Завершено',
    },
    orderModal: {
      title: 'Складская заявка',
      noItemsYet: 'Позиций пока нет',
      tapToAdd: 'Нажми позицию в каталоге, чтобы добавить',
      tabProducts: 'Продукты',
      tabSupplies: 'Расходники',
      searchProductsPlaceholder: 'Поиск продуктов...',
      searchSuppliesPlaceholder: 'Поиск расходников...',
      emptyCatalog: 'Ничего не найдено',
      done: 'Готово',
      setAmount: 'Указать количество',
      clearItems: 'Очистить позиции',
      deleteOrder: 'Удалить заявку',
    },
    createGoodsModal: {
      create: 'Создать',
    },
  },
  tasks: {
    title: 'Задачи',
    sidebarTitle: 'Сегодня',
    sidebarEmptyHeading: 'Нет задач на сегодня',
    sidebarEmptyHint: 'Задачи, назначенные тебе, появятся здесь.',
    selectPrompt: 'Выбери задачу слева.',
    noneAssigned: 'На тебя активных задач сейчас нет.',
    subtasksProgress: '{completed} из {total} подзадач',
    detail: {
      status: {
        completed: 'Выполнена',
        'in-progress': 'В процессе',
        missed: 'Пропущена',
        pending: 'Ожидает',
      },
      subtasks: 'Подзадачи',
      verification: 'Подтверждение',
      reference: 'Референс',
      takePhoto: 'Сделать фото',
      addComment: 'Добавить комментарий',
      submitted: 'Готово',
      markAsDone: 'Отметить выполненной',
      undo: 'Отменить выполнение',
      commentPlaceholder: 'Добавь комментарий…',
      uploadFailed: 'Загрузка не удалась: {message}',
      unknownError: 'неизвестная ошибка',
    },
  },
  settings: {
    title: 'Настройки',
    selectPrinter: 'Выбрать принтер',
    notSetUp: 'Не настроено',
    debugPrinter: 'Тестовый принтер',
    fiscal: {
      cardTitle: 'Фискальные настройки',
      cardSubtitle: 'Фискальные',
      description: 'Настройки фискального принтера.',
      selectedPrinter: 'Выбранный принтер',
      noPrintersFound: 'Принтеров не найдено',
      devMode: 'Дев-режим',
      receiptPreview: 'Превью чека',
      openLog: 'Открыть лог',
      printerLog: 'Лог принтера',
    },
    fiscalActions: {
      cardTitle: 'Фискальные действия',
      cardSubtitle: 'Фискальные',
      description: 'Действия с принтером.',
      printDuplicate: 'Печать дубликата',
      xReport: 'X-отчёт',
      zReport: 'Z-отчёт',
      periodReport: 'Отчёт за период',
    },
    periodReport: {
      title: 'Отчёт за период',
      description:
        'Оборот по налоговым группам и ДДС за выбранные даты, печатается на фискальном принтере.',
      from: 'С',
      to: 'По',
      mode: 'Тип отчёта',
      detailed: 'Подробный',
      brief: 'Краткий',
      withPayments: 'Разбивка по типам платежей',
      print: 'Печать отчёта',
      hint: 'В отчёт попадают только дни, закрытые Z-отчётом.',
    },
    station: {
      cardTitle: 'Настройки станции',
      cardSubtitle: 'Станция',
      description: 'Настройки станции.',
      waitersOrderBoard: 'Доска заказов официантов',
      menuItemUnits: 'Отображаемые единицы измерения',
      noUnitsSelected: 'Единицы не выбраны',
      preferLocalServer: 'Предпочитать локальный сервер',
      resetServerPreference: 'Сбросить выбор сервера',
    },
    push: {
      cardTitle: 'Уведомления',
      cardSubtitle: 'Напоминания по назначенным задачам',
      enableToggle: 'Включить на этом устройстве',
      sendTest: 'Отправить тестовое',
      testDelivered: 'Доставлено {sent} из {total}',
      testFailed: 'Не удалось отправить',
      notSupported: 'Устройство не поддерживает web push.',
    },
  },
}
